export default {
  campaigns: ({ campaigns }) => campaigns,
  campaignsPagination: ({ pagination }) => pagination,
  isLoadingCampaigns: ({ is_loading_campaigns }) => is_loading_campaigns,
  isErrorCampaigns: ({ is_error_campaigns }) => !!is_error_campaigns,
  errorCampaigns: ({ is_error_campaigns }) => is_error_campaigns,
};
